import LazyLoad from "vanilla-lazyload";

const
  lazyLoading = () => import('vanilla-lazyload'),
  everythingLoadedInit = () => {
    lazyLoading().then(() => {
      const lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 600,
        thresholds: "800px 15%"
      })

      document.body.classList.add('page-loaded')
    })
  }

export {everythingLoadedInit}
